import { gsap } from 'gsap';

class MobileMenu {
  constructor() {
    MobileMenu.init();
    MobileMenu.toggleSubMenu();
  }

  static init() {
    const menu = window.wrapper.querySelector('.responsive-menu');
    if (!menu) return;
    const btnMenuMobile = window.wrapper.querySelector('.js-menu-toggle');
    const body = document.querySelector('body');
    const menuBg = menu.querySelector('.responsive-menu__bg');
    const menuItems = ['.responsive-menu__main > li', '.responsive-menu__right > li'];

    btnMenuMobile.addEventListener('click', () => {
      const tl = gsap.timeline();

      if (!body.classList.contains('nav-open')) {
        tl.set(menu, {
          autoAlpha: 1
        });

        tl.to(menuBg, {
          duration: 0.5,
          height: '100%',
          ease: 'power2.inOut'
        });

        tl.fromTo(menuItems, {
          y: -40,
          autoAlpha: 0
        }, {
          stagger: {
            each: 0.06,
            from: 'end'
          },
          duration: 0.5,
          y: 0,
          autoAlpha: 1,
          ease: 'power2.inOut'
        }, '-=0.2');
      } else {
        tl.to(menuItems, {
          stagger: 0.06,
          duration: 0.4,
          y: -40,
          autoAlpha: 0,
          ease: 'power2.inOut'
        });

        tl.to(menuBg, {
          duration: 0.4,
          height: 0,
          ease: 'power2.inOut'
        }, '-=0.3');

        tl.set(menu, {
          autoAlpha: 0
        });
        body.classList.add('nav-closing');

        window.setTimeout(() => {
          body.classList.remove('nav-closing');
        }, 700);
      }

      body.classList.toggle('nav-open');
    });
  }

  static toggleSubMenu() {
    [].forEach.call(window.wrapper.querySelectorAll('.responsive-menu .level--1.menu-item-has-children'), (parent) => {
      const child = parent.querySelector('a');
      child.addEventListener('click', (e) => {

        // Cancel click only on links with preventDefault class (added in WP Menus dashboard)
        if (e.target.classList.contains('preventDefault')) {
          e.preventDefault();
          e.stopPropagation();
        }
        const container = parent.querySelector('.menu.nested');

        if (!container.classList.contains('active')) {
          container.classList.add('active');
          parent.classList.add('submenu-active');
          container.style.height = 'auto';
          const height = container.offsetHeight;
          container.style.height = '0px';
          setTimeout(() => {
            gsap.to(container, {
              height,
              clearProps: 'all'
            });
          }, 0);
        } else {
          parent.classList.toggle('submenu-active');
          gsap.to(container, {
            height: 0,
            onComplete() {
              container.classList.toggle('active');
            }
          });
        }
      });
    });
  }
}

export default MobileMenu;
